import { setState } from 'Utils/Store';

// get initial state from window if possible
export const freeFormInitialState = {};

export const updateScreen = (screenName, content) =>
  setState('freeForm', { [screenName]: { content, isLoaded: true } });
